// React imports
import { useEffect } from 'react';

// React Query import
import { useQuery } from '@tanstack/react-query';

// API and context imports
import { getTrainingAnnotations } from '@utils/api';
import { useProject } from '@contexts/Project.context';
import { matchGeoJsonToFeatures, clearFeatureProperty } from '@utils/map/layer/singleImage';

const SingleImageAnnotationPointLayer = ({ singleImagePointsLayer }) => {
	const { project, pickedTask, trainingDataVisible, dispatch } = useProject();
	const { uuid: projectUuid } = project ?? {};
	const { model_uuid: modelUuid } = pickedTask ?? {};

	// Fetch training annotations only when the toggle is enabled
	const { data: annotationsData } = useQuery({
		queryKey: ['fetchTrainingAnnotations', projectUuid, modelUuid],
		queryFn: () => getTrainingAnnotations(projectUuid, modelUuid),
		enabled: !!projectUuid && !!modelUuid && !!singleImagePointsLayer && trainingDataVisible,
		refetchOnWindowFocus: false,
		retry: false,
	});

	// Match annotation data to grid features on the map layer
	useEffect(() => {
		if (!singleImagePointsLayer) return;

		if (!trainingDataVisible || !annotationsData?.features?.length) {
			clearFeatureProperty(singleImagePointsLayer, 'annotations');
			dispatch({ type: 'setAnnotationClasses', payload: null });
			return;
		}

		const { uniqueClasses } = matchGeoJsonToFeatures({
			layer: singleImagePointsLayer,
			geojsonData: annotationsData,
			propertyKey: 'annotations',
		});

		dispatch({ type: 'setAnnotationClasses', payload: uniqueClasses });
		return () => {
			clearFeatureProperty(singleImagePointsLayer, 'annotations');
			dispatch({ type: 'setAnnotationClasses', payload: null });
		};
	}, [annotationsData, singleImagePointsLayer, trainingDataVisible]);

	
	return null;
};

export default SingleImageAnnotationPointLayer;
